exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-deleted{font-style:italic}.icon-deleted{height:14px;width:14px;vertical-align:middle;margin:-3px 1px 0 0;fill:var(--chat-room-color-message)}.text-ellipsis{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
